module.exports = {
  cs: {
    default: true,
    path: `cs`,
    locale: `cs-CZ`,
    dateFormat: `DD/MM/YYYY`,
    siteLanguage: `cs`,
    ogLanguage: `cs-CZ`,
    defaultTitle: `Luxusní ruční mytí aut`,
    defaultDescription: `Luxusní ruční mytí aut`,
  },
/*   en: {   
    path: `en`,
    locale: `en-US`,
    dateFormat: `DD/MM/YYYY`,
    siteLanguage: `en`,
    ogLanguage: `en_US`,
    defaultTitle: `Quality women's jackets`,
    defaultDescription: `Quality women's jackets`,
  }, */

  uk: {
    path: `uk`,
    locale: `uk-UA`,
    dateFormat: `DD.MM.YYYY`,
    siteLanguage: `uk`,
    ogLanguage: `uk_UA`,
    defaultTitle: `Люксова ручна мийка для автомобілів`,
    defaultDescription: `Люксова ручна мийка для автомобілів`,
  },
}